import { useEffect, useState } from "react";
import { api } from "@/api";

/**
 * Fetch /api/site-settings once per page load and share the result across
 * every consumer. Cheap in-memory cache — no context/provider needed since
 * this data is read-only for the frontend.
 */
let cached = null;
let inflight = null;
const subscribers = new Set();

function notify() {
  subscribers.forEach((cb) => cb(cached));
}

export function useSiteSettings() {
  const [settings, setSettings] = useState(cached);

  useEffect(() => {
    subscribers.add(setSettings);
    if (cached) {
      setSettings(cached);
    } else if (!inflight) {
      inflight = api.get("/site-settings")
        .then(({ data }) => {
          cached = data;
          notify();
        })
        .catch(() => {})
        .finally(() => { inflight = null; });
    }
    return () => { subscribers.delete(setSettings); };
  }, []);

  return settings;
}

// Force a refresh (call after admin saves settings)
export function refreshSiteSettings() {
  cached = null;
  return api.get("/site-settings").then(({ data }) => {
    cached = data;
    notify();
    return data;
  });
}
